import React, { useMemo } from 'react';
import { MdOutlineSatelliteAlt } from 'react-icons/md';

import { Top as TopUI, TopStatusValue } from '@/components/ui/dashboard/Top';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import { GPS_FIX_TYPE } from '@/define/robotStatus';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const Top = ({ robot }) => {
  const gpsRaw = useRobotTelemetry(robot.id, MESSAGE.GPS_RAW_INT);

  const gpsInfo = useMemo(() => {
    if (!gpsRaw) return;

    return `${gpsRaw.satellitesVisible} (${GPS_FIX_TYPE[gpsRaw.fixType].name})`;
  }, [gpsRaw]);

  return (
    <TopUI agentType={robot.model.agentType} owned={robot.isOwned} robotId={robot.id}>
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={gpsInfo} style={{ gap: 4 }} />
    </TopUI>
  );
};

export default Top;
